/* GAGBIZARE_OFFICIAL — storefront behaviour on Shopify's native Cart API */
(function () {
  'use strict';

  /* ---------------- toast ---------------- */
  const CHECK = '<svg viewBox="0 0 448 512" width="14" height="14" fill="currentColor"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>';
  const CROSS = '<svg viewBox="0 0 384 512" width="13" height="13" fill="currentColor"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';
  let toastWrap;
  function toast(opts) {
    if (!toastWrap) {
      toastWrap = document.createElement('div');
      toastWrap.className = 'toast-wrap';
      document.body.appendChild(toastWrap);
    }
    const o = typeof opts === 'string' ? { title: opts } : opts;
    const el = document.createElement('div');
    el.className = 'toast' + (o.type === 'error' ? ' is-error' : '');
    el.innerHTML =
      '<span class="toast-icon ' + (o.type === 'error' ? 'is-error' : 'is-ok') + '">' + (o.type === 'error' ? CROSS : CHECK) + '</span>' +
      '<div class="toast-text"><div class="toast-title">' + (o.title || '') + '</div>' +
      (o.sub ? '<div class="toast-sub">' + o.sub + '</div>' : '') + '</div>' +
      (o.image ? '<img class="toast-img" src="' + o.image + '" alt="">' : '');
    toastWrap.appendChild(el);
    const dur = o.duration || 2800;
    requestAnimationFrame(() => el.classList.add('show'));
    setTimeout(() => el.classList.remove('show'), dur);
    setTimeout(() => el.remove(), dur + 360);
  }

  /* ---------------- cart count ---------------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach((b) => {
      if (n > 0) { b.textContent = n; b.style.display = ''; } else { b.style.display = 'none'; }
    });
  }
  function refreshCount() {
    fetch('/cart.js').then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
  }

  /* ---------------- cart drawer ---------------- */
  function fmtMoney(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'GBP' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }
  async function renderDrawer() {
    const d = getDrawer();
    if (!d) return;
    let cart;
    try { cart = await fetch('/cart.js').then((r) => r.json()); } catch (e) { return; }
    setCount(cart.item_count);
    const list = d.querySelector('[data-cd-items]');
    const empty = d.querySelector('[data-cd-empty]');
    const foot = d.querySelector('[data-cd-foot]');
    const hasItems = cart.items && cart.items.length > 0;
    empty.hidden = hasItems;
    foot.hidden = !hasItems;
    list.innerHTML = '';
    if (!hasItems) return;
    cart.items.forEach((it, i) => {
      const row = document.createElement('div');
      row.className = 'cd-item';
      row.innerHTML =
        '<img class="cd-item-img" src="' + (it.image || '') + '" alt="">' +
        '<div class="cd-item-mid"><div class="cd-item-name">' + it.title + '</div>' +
        '<div class="cd-item-price">' + fmtMoney(it.final_line_price != null ? it.final_line_price : it.price * it.quantity, cart.currency) + '</div>' +
        (it.quantity > 1 ? '<div class="cd-item-qty">Qty: ' + it.quantity + '</div>' : '') + '</div>' +
        '<button class="cd-item-rm" type="button" data-cd-remove="' + (i + 1) + '" aria-label="Remove">' +
        '<svg viewBox="0 0 448 512" width="13" height="13" fill="currentColor"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg></button>';
      list.appendChild(row);
    });
    d.querySelector('[data-cd-subtotal]').textContent = fmtMoney(cart.total_price, cart.currency);
  }
  function openDrawer() {
    const d = getDrawer();
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    renderDrawer();
  }
  function closeDrawer() {
    const d = getDrawer();
    if (!d) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
  }
  async function removeLine(line) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: 0 })
      });
    } catch (e) {}
    renderDrawer();
  }
  /* -------- external Stripe checkout (replaces Shopify's /checkout) --------
     Set PIKO_CHECKOUT_URL to wherever you host the custom checkout app.
     The whole cart is encoded into the URL so the checkout page can price and
     charge it (server-side) with Stripe. */
  // Internal Shopify checkout page (Settings → Checkout → Checkout page URL).
  var PIKO_CHECKOUT_URL = (window.PIKO_CFG && window.PIKO_CFG.checkoutUrl) || '/pages/checkout';
  function encodeCartParam(cart) {
    var items = (cart.items || []).map(function (i) {
      return {
        handle: i.handle,
        qty: i.quantity,
        title: i.product_title || i.title,
        price: i.price,           // pence (display only; the server re-prices)
        image: i.image,
        variant_id: i.variant_id || i.id
      };
    });
    return btoa(unescape(encodeURIComponent(JSON.stringify(items))))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  async function goToExternalCheckout(roblox) {
    var cart;
    try { cart = await fetch('/cart.js').then(function (r) { return r.json(); }); }
    catch (e) { window.location.href = '/checkout'; return; } // fallback if offline
    if (!cart.items || !cart.items.length) { toast({ type: 'error', title: 'Your cart is empty' }); return; }
    var sep = PIKO_CHECKOUT_URL.indexOf('?') >= 0 ? '&' : '?';
    var url = PIKO_CHECKOUT_URL + sep + 'cart=' + encodeCartParam(cart);
    if (roblox) url += '&roblox=' + encodeURIComponent(roblox);
    window.location.href = url;
  }

  async function drawerCheckout() {
    const d = getDrawer();
    const u = d.querySelector('[data-cd-username]');
    if (!u.value.trim()) {
      u.focus();
      u.classList.add('cd-input-err');
      toast({ type: 'error', title: 'Roblox username required', sub: 'We need it to deliver your items.' });
      return;
    }
    u.classList.remove('cd-input-err');
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Roblox Username': u.value.trim() } })
      });
    } catch (e) {}
    goToExternalCheckout(u.value.trim());
  }

  /* ---------------- one item at a time + 3s loader ---------------- */
  let busy = false;
  async function addToCart(btn) {
    if (busy || btn.classList.contains('loading')) return;
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    busy = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (cart.item_count > 0) {
        toast({ type: 'error', title: 'One item at a time', sub: 'You can only add one item to your cart at a time.' });
        busy = false;
        return;
      }
    } catch (e) { busy = false; return; }

    const orig = btn.innerHTML;
    btn.classList.add('loading');
    btn.disabled = true;
    btn.innerHTML = '<span class="dots"><span></span><span></span><span></span></span>';

    setTimeout(async () => {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Could not add to cart');
        toast({ title: 'Added to cart', sub: btn.getAttribute('data-name') || '', image: btn.getAttribute('data-image') || '' });
        refreshCount();
        openDrawer();
      } catch (err) {
        toast({ type: 'error', title: 'Could not add', sub: err.message });
      } finally {
        btn.classList.remove('loading');
        btn.disabled = false;
        btn.innerHTML = orig;
        busy = false;
      }
    }, 3000);
  }

  /* ---------------- wire up ---------------- */
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add); return; }
    // cart drawer
    const cartBtn = e.target.closest('.cart-btn');
    if (cartBtn && getDrawer()) { e.preventDefault(); openDrawer(); return; }
    const rm = e.target.closest('[data-cd-remove]');
    if (rm) { removeLine(rm.getAttribute('data-cd-remove')); return; }
    if (e.target.closest('[data-cd-checkout]')) { drawerCheckout(); return; }
    if (e.target.closest('[data-cd-close]') || e.target.matches('.cd-overlay')) { closeDrawer(); return; }
    // change-game dropdown
    const cgBtn = e.target.closest('.change-game');
    if (cgBtn) { e.preventDefault(); cgBtn.closest('.cg-wrap').classList.toggle('open'); return; }
    document.querySelectorAll('.cg-wrap.open').forEach((w) => w.classList.remove('open'));
  });

  // cart page: require Roblox username, then send to the external Stripe checkout
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-cart-form]');
    if (!form) return;
    const u = form.querySelector('[name="attributes[Roblox Username]"]');
    if (u && !u.value.trim()) {
      e.preventDefault();
      u.focus();
      toast({ type: 'error', title: 'Roblox username required', sub: 'We need it to deliver your items.' });
      return;
    }
    e.preventDefault(); // don't submit to Shopify's /checkout
    goToExternalCheckout(u ? u.value.trim() : '');
  });

  // section-row arrows
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-scroll]');
    if (!arrow) return;
    const row = document.getElementById(arrow.getAttribute('data-scroll'));
    if (row) row.scrollBy({ left: Number(arrow.getAttribute('data-dir')) * row.clientWidth * 0.8, behavior: 'smooth' });
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('DOMContentLoaded', refreshCount);
  refreshCount();

  /* ---------------- animated topographic background ---------------- */
  (function () {
    const canvas = document.getElementById('topo');
    if (!canvas || !canvas.getContext) return;
    const ctx = canvas.getContext('2d', { alpha: false });
    const perm = new Uint8Array(512);
    (function () { const p = new Uint8Array(256); let s = 1337, i; for (i = 0; i < 256; i++) p[i] = i; const r = () => { s = (s * 16807) % 2147483647; return s / 2147483647; }; for (i = 255; i > 0; i--) { const j = (r() * (i + 1)) | 0, t = p[i]; p[i] = p[j]; p[j] = t; } for (i = 0; i < 512; i++) perm[i] = p[i & 255]; })();
    const fade = (t) => t * t * t * (t * (t * 6 - 15) + 10);
    const vr = (i, j, k) => perm[(i + perm[(j + perm[k & 255]) & 255]) & 255] / 255;
    function n3(x, y, z) { const xi = Math.floor(x), yi = Math.floor(y), zi = Math.floor(z), u = fade(x - xi), v = fade(y - yi), w = fade(z - zi), X = xi & 255, Y = yi & 255, Z = zi & 255; const c000 = vr(X, Y, Z), c100 = vr(X + 1, Y, Z), c010 = vr(X, Y + 1, Z), c110 = vr(X + 1, Y + 1, Z), c001 = vr(X, Y, Z + 1), c101 = vr(X + 1, Y, Z + 1), c011 = vr(X, Y + 1, Z + 1), c111 = vr(X + 1, Y + 1, Z + 1); const x00 = c000 + (c100 - c000) * u, x10 = c010 + (c110 - c010) * u, x01 = c001 + (c101 - c001) * u, x11 = c011 + (c111 - c011) * u, y0 = x00 + (x10 - x00) * v, y1 = x01 + (x11 - x01) * v; return y0 + (y1 - y0) * w; }
    const fbm = (x, y, z) => n3(x, y, z) * 0.65 + n3(x * 2.1, y * 2.1, z * 1.6) * 0.35;
    /* rendered at reduced resolution and stretched by CSS — big paint saving */
    const CELL = 24, SCALE = 0.0074, LEVELS = 7, RES = 1.6; let W, H, cols, rows, field;
    function resize() { W = canvas.width = Math.ceil(innerWidth / RES); H = canvas.height = Math.ceil(innerHeight / RES); cols = Math.ceil(W / CELL) + 2; rows = Math.ceil(H / CELL) + 2; field = new Float32Array(cols * rows); }
    function render(time) {
      const drift = time * 0.04;
      for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) field[r * cols + c] = fbm(c * CELL * SCALE + drift, r * CELL * SCALE, time);
      const g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#0b2413'); g.addColorStop(.55, '#08190e'); g.addColorStop(1, '#051109'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      const rg = ctx.createRadialGradient(W * .5, H * .3, 0, W * .5, H * .3, Math.max(W, H) * .72); rg.addColorStop(0, 'rgba(70,240,127,0.13)'); rg.addColorStop(1, 'rgba(70,240,127,0)'); ctx.fillStyle = rg; ctx.fillRect(0, 0, W, H);
      for (let li = 0; li < LEVELS; li++) {
        const level = (li + 1) / (LEVELS + 1), idx = li % 4 === 0; ctx.beginPath();
        for (let r = 0; r < rows - 1; r++) for (let c = 0; c < cols - 1; c++) {
          const i = r * cols + c, tl = field[i], tr = field[i + 1], br = field[i + cols + 1], bl = field[i + cols], x = c * CELL, y = r * CELL, p = [];
          if ((tl > level) !== (tr > level)) p.push(x + CELL * ((level - tl) / (tr - tl)), y);
          if ((tr > level) !== (br > level)) p.push(x + CELL, y + CELL * ((level - tr) / (br - tr)));
          if ((br > level) !== (bl > level)) p.push(x + CELL * ((level - bl) / (br - bl)), y + CELL);
          if ((bl > level) !== (tl > level)) p.push(x, y + CELL * ((level - tl) / (bl - tl)));
          if (p.length >= 4) { ctx.moveTo(p[0], p[1]); ctx.lineTo(p[2], p[3]); }
          if (p.length >= 8) { ctx.moveTo(p[4], p[5]); ctx.lineTo(p[6], p[7]); }
        }
        ctx.strokeStyle = idx ? 'rgba(140,255,178,0.26)' : 'rgba(100,250,150,0.11)'; ctx.lineWidth = idx ? 1.5 : 1; ctx.stroke();
      }
    }
    let raf, last = 0, time = 0, animate = true, lastFrame = 0;
    function loop(now) { raf = requestAnimationFrame(loop); if (now - last < 50) return; const dt = Math.min(now - last, 80); last = now; time += dt * 0.00022; lastFrame = performance.now(); render(time); }
    function start() { if (animate) { last = performance.now(); cancelAnimationFrame(raf); raf = requestAnimationFrame(loop); } }
    // keep animating in contexts where rAF is suspended (embedded previews, throttled tabs)
    setInterval(() => { if (animate && performance.now() - lastFrame > 500) { time += 0.022; lastFrame = performance.now(); render(time); } }, 100);
    resize();
    render(0);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { animate = false; } else start();
    let rt; addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { resize(); render(time); }, 150); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) cancelAnimationFrame(raf); else start(); });
  })();
})();
